import { INormalized } from '@bimser/core';
import { List, Map } from 'immutable';
import { WebInterfaceBaseState } from '../../common/base/state';
import { FlexPanel } from '../entities/FlexPanelFactory';

export default function getStateForSaga(
	state: WebInterfaceBaseState
): INormalized<Map<string, FlexPanel>, List<string>> {
	const returnValue: INormalized<Map<string, FlexPanel>, List<string>> = {
		entities: Map<string, FlexPanel>(),
		result: List()
	};

	returnValue.entities = state.layouts.contentLayout.entities.panels;

	returnValue.result = state.layouts.contentLayout.result.panels;

	return returnValue;
}

export const animationDelay = 500;
